<template>
  <div class="d-flex justify-center stepIconContainer" :class="{ mobileStep: isMobileSized }">
    <div class="d-flex iconWrapper">
      <div
        class="d-flex align-center justify-center stepIcon"
        :class="{ selected: currentView === 'survey' }"
      >
        <v-icon dense>mdi-human-greeting</v-icon>
      </div>
      <div
        class="d-flex align-center justify-center stepIcon"
        :class="{ selected: currentView === 'solutions' }"
      >
        <v-icon dense>mdi-library-shelves</v-icon>
      </div>
      <div
        class="d-flex align-center justify-center stepIcon"
        :class="{ selected: currentView === 'ads' }"
      >
        <v-icon dense>mdi-palette</v-icon>
      </div>
      <div
        class="d-flex align-center justify-center stepIcon"
        :class="{ selected: currentView === 'advertiser' }"
      >
        <v-icon dense>mdi-calendar-account</v-icon>
      </div>
      <div
        class="d-flex align-center justify-center stepIcon"
        :class="{ selected: currentView === 'launch' }"
      >
        <v-icon dense>mdi-rocket-launch</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepIcons',
  props: {
    currentView: String,
    isMobileSized: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.iconWrapper {
  width: 275px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1em;
  overflow: hidden;
  &::before {
    position: absolute;
    top: calc(50% - 1px);
    right: 16px;
    left: 16px;
    content: '';
    background-color: grey;
    height: 2px;
  }
}

.stepIcon {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #777;
  padding: 1rem;
  width: 24px;
  height: 24px;
  border: 1px solid black;
  border-radius: 16px;
  background-color: white;
  &.selected {
    background-color: #ffc58e;
  }
}

@media screen and (min-width: 1000px) and (max-width: 1049px) {
  .iconWrapper {
    width: 200px;
    .stepIcon {
      width: 15px;
      height: 15px;
      padding: 13px;
    }
  }
}
@media screen and (min-width: 1050px) and (max-width: 1099px) {
  .iconWrapper {
    width: 250px;
    .stepIcon {
      width: 20px;
      height: 20px;
      padding: 16px;
    }
  }
}

.stepIconContainer {
  margin-top: 86px;
  &.mobileStep {
    margin-top: 0;
  }
}
</style>
